import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import secureStorage from "../../../../../services/secureStorage";
import { SS_ROLE } from "../../../../../utility/constants/secureStorageManager";
import {
  ADMIN_USER,
  OPERATIONS,
  SUPPORT,
} from "../../../../../utility/constants/valueConstants";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import custom_getvalue from "../../../../components/main_comps/custom_getvalue";
import CustomSelect from "../../../../components/main_comps/custom_select";

const Container = ({ title, value, loop = false }) => {
  return (
    <div style={{ display: "flex", marginBottom: "20px" }}>
      <p
        style={{
          color: "#000000",
          fontSize: "14px",
          fontWeight: "500",
          width: "180px",
        }}
      >
        {title}
      </p>
      {loop ? (
        <div style={{ display: "flex" }}>
          {value?.map((service, index) => {
            return (
              <>
                <p
                  style={{
                    color: "#38369C",
                    fontSize: "14px",
                    textTransform: "capitalize",
                    fontWeight: "500",
                  }}
                >
                  {service?.serviceType}
                </p>
                {index < value.length - 1 && (
                  <p
                    style={{
                      color: "#38369C",
                      fontSize: "14px",
                      fontWeight: "500",
                      margin: "0px 5px",
                    }}
                  >
                    {"&"}
                  </p>
                )}
              </>
            );
          })}
        </div>
      ) : (
        <p style={{ color: "#3A3A3A", fontSize: "14px" }}>{value}</p>
      )}
    </div>
  );
};

const inputStyle = {
  backgroundColor: "#F3F3F3",
  alignSelf: "center",
  height: 40,
  boxShadow: "none",
  outline: "none",
  paddingLeft: 10,
  boxSizing: "border-box",
  borderRadius: "5px",
  width: "100%",
};
const containerStyle = {
  padding: 0,
  maxWidth: 300,
  minWidth: "250px",
  width: "100%",
  height: "40px",
};

const BasicDetails = ({ data, isEditClicked = false, onChange, role }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [service, setService] = useState("");
  const [industry, setIndustry] = useState("");

  const IndustryType = [
    {
      label: "Corporate",
      value: "Corporate",
    },
    {
      label: "Crypto",
      value: "Crypto",
    },
    {
      label: "Gaming",
      value: "Gaming",
    },
  ];
  function getValue(arr, finder) {
    return arr.find((data) => data?.value === finder);
  }
  const handleData = () => {
    if (!isEditClicked) {
      setFirstName(data?.firstName);
      setLastName(data?.lastName);
      setMobileNumber(data?.mobileNumber);
      setEmail(data?.email);
      setIndustry(data?.industryType);
    }
    if (isEditClicked) {
      setIndustry(getValue(IndustryType, industry));
    }
  };

  useEffect(() => {
    handleData();
    //
  }, [isEditClicked, data]);

  useEffect(() => {
    onChange({
      firstName: custom_getvalue(firstName, data?.firstName),
      lastName: custom_getvalue(lastName, data?.lastName),
      email: custom_getvalue(email, data?.email),
      mobileNumber: custom_getvalue(mobileNumber, data?.mobileNumber),
      industryType: custom_getvalue(industry?.value, data?.industryType),
    });
  }, [firstName, lastName, email, mobileNumber, industry]);

  return (
    <div
      style={{
        padding: "10px 20px",
        flexWrap: "wrap",
        display: "flex",
        flexDirection: "row",
      }}
    >
      {isEditClicked ? (
        <>
          <div style={{ width: "50%", minWidth: "400px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"First Name"}
              </p>
              <CustomInput
                value={firstName}
                onChange={(data) => setFirstName(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="First Name"
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Last Name"}
              </p>
              <CustomInput
                value={lastName}
                onChange={(data) => setLastName(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Last Name"
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Email Id"}
              </p>
              <CustomInput
                value={email}
                onChange={(data) => setEmail(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Email id"
                validator="email"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Mobile Number"}
              </p>
              <CustomInput
                value={mobileNumber}
                onChange={(data) => setMobileNumber(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Mobile number"
                validator="mobile"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              {data?.industryType ? (
                <Container
                  title="Industry Type:"
                  value={data?.industryType ? data?.industryType : "N/A"}
                />
              ) : (
                <>
                  <p
                    style={{
                      color: "#000000",
                      fontSize: "14px",
                      fontWeight: "500",
                      width: "180px",
                    }}
                  >
                    {"Industry Type"}
                  </p>
                  <CustomSelect
                    placeholder="Select Industry Type"
                    style={{
                      ...containerStyle,
                      position: "",
                      width: "100%",
                    }}
                    value={industry}
                    options={IndustryType}
                    onChange={(data) => {
                      setIndustry(data);
                    }}
                  />{" "}
                </>
              )}
            </div>
          </div>
          <div style={{ width: "50%" }}>
            <Container title="Businness Name :" value={data?.businessName} />
            <Container title="Businness Type :" value={data?.businessType} />
            <Container title="Businness PAN card :" value={data?.panNumber} />
            <Container title="Businness GST No :" value={data?.gstNumber} />
          </div>
        </>
      ) : (
        <>
          <div style={{ width: "50%", minWidth: "400px" }}>
            <Container
              title="Name:"
              value={data?.firstName + " " + data?.lastName}
            />
            <Container title="Email ID:" value={data?.email} />
            <Container
              title="Mobile Number:"
              value={"+91 " + data?.mobileNumber}
            />
            <Container
              title="Service Type:"
              value={data?.service}
              loop={true}
            />
            <Container
              title="Industry Type:"
              value={data?.industryType ? data?.industryType : "N/A"}
            />
          </div>
          <div style={{ width: "50%" }}>
            <Container title="Businness Name :" value={data?.businessName} />
            <Container title="Businness Type :" value={data?.businessType} />
            <Container title="Businness PAN card :" value={data?.panNumber} />
            <Container title="Businness GST No :" value={data?.gstNumber} />
          </div>
        </>
      )}
    </div>
  );
};

export default BasicDetails;
